'use client'

import Button from "./Button"

export default function ClientButton(props) {

  return <Button {...props} client={true}></Button>
}